// Documentation is located https://github.com/kidjp85/react-id-swiper/tree/1.6.4

import React, { Component } from 'react';
import Swiper from 'react-id-swiper';

const icons = [
  {
    sector_name: 'Manufacturing',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021/icons-for-mobile-carousel/fcmic-icon-manufacturing.svg',
    top: 115,
    left: 72
  },
  {
    sector_name: 'Travel',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021/icons-for-mobile-carousel/fcmic-icon-travel.svg',
    top: 116,
    left: 50
  },
  {
    sector_name: 'Music',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021/icons-for-mobile-carousel/fcmic-icon-music.svg',
    top: 116,
    left: 50
  },
  {
    sector_name: 'Corporate Responsibility',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021/icons-for-mobile-carousel/fcmic-icon-corp-responsibility.svg',
    top: 114,
    left: 70
  },
  {
    sector_name: 'Workplace',
    sector_image:
      'https://images.fastcompany.net/multisite_files/fastcompany/mic2021/icons-for-mobile-carousel/fcmic-icon-workplace.svg',
    top: 125,
    left: 50
  }
];

class MicMobileIconCarousel extends Component {
  constructor(props) {
    super(props);
    this.swiperResize = this.swiperResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.swiperResize);
    setTimeout(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    }, 400);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.swiperResize);
  }

  swiperResize() {
    if (this.swiper) {
      this.swiper.update();
    }
  }

  render() {
    const settings = {
      navigation: {
        nextEl: '.carousel-next-btn-mobile',
        prevEl: '.carousel-prev-btn-mobile'
      },
      centeredSlides: true,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false
      },
      renderPrevButton: () => <button className="carousel-prev-btn-mobile" />,
      renderNextButton: () => <button className="carousel-next-btn-mobile" />
    };

    return (
      <div>
        <Swiper
          {...settings}
          ref={node => {
            if (node) this.swiper = node.swiper;
          }}
        >
          {icons.map((item, index) => (
            <article key={`${index}`} style={{ padding: 10 }}>
              <div className="mobile-icon-container">
                <img
                  className="mobile-icon-img"
                  src={item.sector_image}
                  alt={item.sector_name}
                />
                <img
                  alt="platform-icon"
                  className="mobile-icon-platform-img"
                  style={{ top: item.top, left: item.left }}
                  src="https://images.fastcompany.net/multisite_files/fastcompany/mic2021/icons-for-mobile-carousel/fc-mic-icon-platform.svg"
                />
              </div>
            </article>
          ))}
        </Swiper>
      </div>
    );
  }
}

export default MicMobileIconCarousel;
